import { movies } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

const syncNotes = [
  '院线同步通常描述影院上映与后续线上可看时间之间的安排关系，受排片、密钥与发行窗口影响。',
  '同一部影片在不同城市的可看时间可能不同，具体以当地影院公布的信息为准。',
  '本分区内容为一般性整理，用于帮助你判断关注节奏，不构成对具体上映时间的承诺。',
];

export default function CinemaSync() {
  const syncMovies = movies.filter((m) => m.isCinemaSync);

  return (
    <section id="cinema" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="In Cinemas"
          title="院线同步：正在大银幕上的影片"
          desc="想在影院里先看为快，可以从这一分区了解当前处于院线档期附近的影片，以及它们的基本信息与看点。"
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
          {syncMovies.map((movie) => (
            <article
              key={movie.id}
              className="group flex gap-4 p-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-28 md:w-32 shrink-0 rounded-md overflow-hidden">
                <div className="w-full aspect-[2/3]">
                  <img
                    src={movie.poster}
                    alt={`${movie.title} 影片封面`}
                    title={`${movie.title} 星辰影院院线同步`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="min-w-0 flex flex-col">
                <div className="flex items-center gap-2">
                  <h3 className="text-base md:text-lg font-bold text-foreground-950 truncate">{movie.title}</h3>
                  <span className="shrink-0 flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent-100 text-accent-800 text-xs font-semibold">
                    <i className="ri-star-fill text-[11px]" />
                    {movie.rating.toFixed(1)}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">
                  {movie.director} 导演 · {movie.duration} 分钟 · {movie.region}
                </p>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-4">{movie.summary}</p>
                <div className="mt-auto pt-3 flex flex-wrap gap-1.5">
                  {movie.genres.map((g) => (
                    <span key={g} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]">
                      {g}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 p-5 md:p-6 rounded-lg bg-secondary-50 border border-secondary-200">
          <h3 className="flex items-center gap-2 text-sm md:text-base font-bold text-secondary-900">
            <i className="ri-information-line text-lg" />
            关于「院线同步」的几点说明
          </h3>
          <ul className="mt-3 grid grid-cols-1 md:grid-cols-3 gap-3">
            {syncNotes.map((note) => (
              <li key={note} className="flex gap-2 text-xs md:text-sm text-foreground-700 leading-relaxed">
                <i className="ri-checkbox-circle-line text-secondary-500 shrink-0 mt-0.5" />
                <span>{note}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}